import { Crown, Lock, ShieldCheck } from "lucide-react";

const TrustPillarsSection = () => {
  const pillars = [
    {
      icon: ShieldCheck,
      title: "Verified Breeders",
      description: "ID, registry, and veterinary records required. Every breeder is thoroughly vetted.",
    },
    {
      icon: Lock,
      title: "Protected Transactions",
      description: "Escrowed payments and dispute mediation. Your investment is protected.",
    },
    {
      icon: Crown,
      title: "Premium Network",
      description: "Browse freely and connect with verified breeders, trusted providers, and quality bloodlines.",
    },
  ];

  return (
    <section className="py-24 px-6 md:px-12 bg-[#050505]">
      <div className="max-w-7xl mx-auto">
        <p className="text-xs tracking-[0.3em] uppercase text-[#D4AF37] mb-4">Trust & Security</p>
        <h2 className="text-4xl md:text-5xl tracking-tight text-[#EDEDED] mb-16">Why Breedling</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {pillars.map((pillar) => (
            <div key={pillar.title} className="pillar-card">
              <pillar.icon className="pillar-icon" strokeWidth={1} />
              <h3 className="text-xl md:text-2xl text-[#EDEDED] mb-4">{pillar.title}</h3>
              <p className="text-[#A1A1AA] font-light leading-relaxed">{pillar.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustPillarsSection;
